<template>
  <div
    class="backlogworkpackagelist"
    >
    <div v-if="wbworkpackage.is_open" class="backlogworkpackagelist-selected"/>
    <Workpackage v-if="small_width" :workpackage="wbworkpackage" :style="wbworkpackage.is_open? 'border: solid 2px white !important':''"/>
    <template v-if="!small_width">
      <div class="d-flex workpackage-text-wrapper">
        <div class="basic-flex-col mr-1">
          <div class="basic-flex-row">
            <TIcon size="14" name="person-standing" />
            <TText size="11" :text="wbworkpackage.manpower_planned" />
          </div>
          <div class="basic-flex-row">
            <TIcon size="14" name="stopwatch" />
            <TText size="11" :text="wbworkpackage.time_effort_planned" />
          </div>
        </div>
        <TContextInformation>
          <template #default>
            <Workpackage :workpackage="wbworkpackage"/>
          </template>
          <template #information>
            <WorkpackageInformation :workpackage="wbworkpackage" prefix="wb" histprefix="" />
          </template>
        </TContextInformation>
        <TText max_lines="2" :text="wbworkpackage.name" class="ml-1"/>
      </div>
        <div
        v-if="date"
        class="backlogworkpackagelistdate"
        @click.prevent.stop="show_date_picker = true"
        >
        <template v-if="wbworkpackage.position !== -1">
          <div>{{date.start}}</div>
          <div>{{date.end}}</div>
        </template>
        <div v-else>set date</div>
        <BacklogDatePicker
          v-if="show_date_picker"
          :date="date"
          :wbworkpackage_position="wbworkpackage.position"
          @clickOutside="show_date_picker = false"
          @clickClose="show_date_picker = false"
          @updatePosition="$emit('updatePosition', $event)"
          @updateLength="$emit('updateLength', $event)"
          @clickRemove="$emit('clickRemove')"
          />
      </div>
    </template>
  </div>
</template>
<script>
  import Workpackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
  import TText from '@/components/Taktify/TText.component.vue';
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  import BacklogDatePicker from '@/components/TaktPlanBacklogs/BacklogDatePicker.component.vue';
  import WorkpackageInformation from '@/components/ProjectTaktPlan/WorkpackageInformation.component.vue';
  import TContextInformation from '@/components/Taktify/TContextInformation.component.vue';

  export default {
    props: ['wbworkpackage', 'date', 'small_width'],
    components: {
      Workpackage,
      TText,
      TIcon,
      BacklogDatePicker,
      WorkpackageInformation,
      TContextInformation
    },
    data: () => ({
      show_date_picker: false,
    }),
  }
</script>
<style>
  .backlogworkpackagelist {
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 5px;
    border-bottom: 1px dashed grey;
    cursor: pointer;
    user-select: none;
    justify-content: space-between;
  }
  .backlogworkpackagelistdate {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: solid 0.5px white;
    width: 68px;
    height: 40px;
    font-size: 12px;
    font-weight: 300;
    flex-shrink: 0;
  }
  .backlogworkpackagelist-selected {
    background-color: white;
    margin-left: -5px;
  }

  .workpackage-text-wrapper {
    align-items: center;
  }
</style>
